import { FunctionId } from '@/types/function-id';
import {
    isUsageAmountWhere,
    UsageAmountWhere,
} from '@eureka/shared/edition-upgrade/src/constants';

/**
 * 定义home agent使用的使用量条件
 */
const HOME_AGENT_USAGE_AMOUNT_WHERE = [
    UsageAmountWhere.TRIZ,
    UsageAmountWhere.DEEPCOST,
    UsageAmountWhere.TECH_RESEARCH,
    UsageAmountWhere.COMPANY_SEARCH,
    UsageAmountWhere.COMPETITIVE_LANDSCAPE,
    UsageAmountWhere.DEEP_RESEARCH,
    UsageAmountWhere.TECH_MIND,
    UsageAmountWhere.VALIDATION,
    UsageAmountWhere.TECH_RISK
] as const;

type HomeAgentUsageAmountWhere = typeof HOME_AGENT_USAGE_AMOUNT_WHERE[number];

export function resolveUsageAmountWhere(type: unknown): UsageAmountWhere {
    if (isUsageAmountWhere(type)) return type;

    const routeType = typeof type === 'string' ? type.replace(/^rd_/, '') : '';
    return isUsageAmountWhere(routeType) ? routeType : UsageAmountWhere.TRIZ;
}

export function resolveFunctionId(type: unknown): FunctionId {
    const usageAmountWhere = resolveUsageAmountWhere(type);
    const agentName = usageAmountWhere.startsWith('rd_')
        ? usageAmountWhere
        : `rd_${usageAmountWhere}`;
    return Object.values(FunctionId).find(functionId => functionId === agentName) ?? FunctionId.TRIZ;
}

export function getUsageAmountWhereFromLocation(location: Location = window.location): UsageAmountWhere {
    const hashQuery = location.hash.split('?')[1] ?? '';
    const hashType = new URLSearchParams(hashQuery).get('type');
    const searchType = new URLSearchParams(location.search).get('type');
    return resolveUsageAmountWhere(hashType ?? searchType);
}

export function isHomeAgentUsageAmountWhere(
    usageAmountWhere: UsageAmountWhere
): usageAmountWhere is HomeAgentUsageAmountWhere {
    return HOME_AGENT_USAGE_AMOUNT_WHERE.some(agentUsageAmountWhere =>
        agentUsageAmountWhere === usageAmountWhere
    );
}
